// extracted by mini-css-extract-plugin
module.exports = {"kycWarning":"styles_kycWarning__Fp932"};